<template>
    <div class="relative">
        <div class="flex items-center py-4">
            <img class="w-[18px] h-5" src="@/assets/icon/edocument/ic-attached-file.png" alt="">
            <div class="ml-2"> 
                <div class="text-14 text-a-gray-555555">{{ itemEndosement.Title }}</div>
                <div class="text-12 text-a-black-484848 mt-1">{{ itemEndosement.PolicyNo }}-{{ itemEndosement.EndosementNo }}</div>
            </div>
        </div>
        <img class="absolute right-2 top-5" src="@/assets/icon/edocument/ic-download.png" alt="" @click="openFile()">
    </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        itemEndosement: {
            type: Object,
        },
    },
    setup: function (props) {
        const openFile = () => {
            window.open(props.itemEndosement.Url, '_blank')
        }
        return {
            openFile
        }
    }
})
</script>